import { StatusChip } from "./StatusChip";

interface FeatureCardProps {
  readonly title: string;
  readonly body: string;
  readonly chip?: string;
}

export function FeatureCard({ title, body, chip }: FeatureCardProps) {
  return (
    <article className="feature-card">
      {chip ? <StatusChip label={chip} /> : null}
      <h2>{title}</h2>
      <p>{body}</p>
    </article>
  );
}
